import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { CompanyContact } from '../../models/Contact';

interface GetCompanyOrphanContactsPayload {
  company_id: string;
}

interface GetCompanyOrphanContactsResponse {
  contacts: CompanyContact[];
  /** Name of each owner, former members included; a deleted account is missing */
  ownerNames: Record<string, string>;
}

/**
 * Contacts of the company's members that no number shows any more: a number they held went to someone
 * else without them. Supervisor only.
 */
export async function getCompanyOrphanContacts(
  payload: GetCompanyOrphanContactsPayload,
  auth: Authentication,
): Promise<GetCompanyOrphanContactsResponse> {
  try {
    if (!payload.company_id) {
      throw new GetCompanyOrphanContactsFailure('company_id est requis');
    }

    const response = await HttpClient.post('/company/contacts/orphans', payload, auth.token);

    return {
      contacts: (response.data?.contacts ?? []) as CompanyContact[],
      ownerNames: (response.data?.owner_names ?? {}) as Record<string, string>,
    };
  } catch (e) {
    console.error('getCompanyOrphanContacts error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyOrphanContactsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyOrphanContactsFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyOrphanContactsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}